import React from 'react';

import './desktop-community-share-style.scss';
import DesktopAppDownload from '@src/componentsNew/AppDownload/DesktopAppDownload';

const DesktopCommunitySharePage = ({ deepLink }) => {
  return (
    <div id="desktop-community-share-wrapper">
      <DesktopAppDownload deepLink={deepLink} infoText={`Community posts can be viewed\non Maccaron App.`} />
    </div>
  );
};

export default DesktopCommunitySharePage;
